import type { RouteResource } from 'react-resource-router';

import type { UserResourceType } from '../../common/utils/types';

import { eocUserResource } from './user-resource';

export { eocUserResource } from './user-resource';

export const eocCommonResources = (): RouteResource<UserResourceType>[] => [eocUserResource];
